import { boot } from 'quasar/wrappers'
import CurrencyFilter from 'src/filters/currency'
import FileSizeFilter from 'src/filters/file-size'
import DateRelative from 'src/filters/date-relative'

export default boot(({ app }) => {
  app.config.globalProperties.$filters = {
    currency: CurrencyFilter,
    fileSize: FileSizeFilter,
    dateRelative: DateRelative,
  }
})
